export const LAYOUT = {
  header: 'Header',
  pageContent: 'PageContent',
};

export const COLOR = {
  white: 'White',
  transparent: 'Transparent',
  blue: 'Blue',
};

type InputLayout = (typeof LAYOUT)[keyof typeof LAYOUT];

type InputColor = (typeof COLOR)[keyof typeof COLOR];

export interface Variation {
  layout: InputLayout;
  color: InputColor;
}

/* eslint-disable camelcase */

interface Title {
  text: string;
  color: string;
}

interface Image {
  url: string;
}

interface Data {
  firebase_screen: string;
  search_term: string;
  section_name: string;
  item_name?: string;
}

interface Impression {
  screenName: string;
  eventName: string;
  type: string;
  data: Data;
}

interface LoggingMeta {
  impressions: Array<Impression>;
  clicks?: Array<Impression>;
}

export interface Link {
  id: string;
  titles: Array<Title>;
  image: Image;
  linkUrl: string;
  loggingMeta: LoggingMeta;
}

export interface LinkGroup {
  sectionType: string;
  viewType: string;
  loggingMeta: LoggingMeta;
  links: Array<Link>;
}

export interface Banner {
  sectionType: string;
  viewType: string;
  image: Image;
  titles: Array<Title>;
  subTitles?: Array<Title>;
  linkUrl: string;
  loggingMeta: LoggingMeta;
}

export interface Sections {
  sections: Array<LinkGroup | Banner>;
}
export interface SearchOffersResponse {
  data: Sections;
}
